import JobView from "./JobView.vue"
import JobEdit from "./JobEdit.vue"

const base = "/job"

export default [
    {
        path: base + "/new",
        name: "jobnew",
        props: { new: true },
        component: JobEdit
    },
    {
        path: base + "/:uuid/edit",
        name: "jobedit",
        props: true,
        component: JobEdit
    },
    {
        path: base + "/:uuid",
        name: "jobdetailform",
        props: true,
        component: JobView
    },
    {
        path: base + "/:copyFromUuid/copy",
        name: "jobcopy",
        props: true,
        component: JobEdit
    }
]
